import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { DataService } from '../data.service';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class AuthGuard implements CanActivate {

  constructor(private dataService: DataService, private router: Router) {

  }
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

    if( !!this.dataService.subuser_info && !!this.dataService.subuser_info.verified ){
      return true; // ????
    }

    let token = window.localStorage.getItem('user_token');
    let valid = window.localStorage.getItem('user_token_valid_until');
    let token_is_valid = false;

    if (!!token && !!valid) {
      let now = new Date();
      let valid_date = new Date(valid);
      token_is_valid = valid_date > now;
    }
    // check token validity. If it's valid, asume a logged in user. Load up details through service
    if (token_is_valid) {
      this.dataService.is_logged_in = true;
      this.dataService.loadUserDetails();
      return true
    }
    else {
      // since we don't have a valid token, redirect to the loginpage
      this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
      return false;
    }


  }
}



// WEBPACK FOOTER //
// /Users/matthijs/projects/PHILIPS/philips-dental-pro/shop/src/app/guards/auth.guard.ts